<template>
  <div class="sub-form-container">
    <div class="intro">
      <img src="../assets/images/subscribe-banner.jpg" alt="Banner Image">
      <div class="description">
        <h1>MyanmarAPN Service Order Form</h1>
        <p>ကြိုတင်ငွေပေးစရာမလိုသော အလိုအလျောက် အင်တာနက်ဝန်ဆောင်မှုစာချုပ်ချုပ်ဆိုခြင်း</p>
        <p class="info">တပ်ဆင်ခ - အခမဲ့ (သုံးလစာချုပ်-တစ်လချင်းပေးသွင်းရန်သာ လိုအပ်သည်)</p>
        <p>Sales ဝန်ထမ်းများမှ လူကြီးမင်းသို့ တိုက်ရိုက် ဆက်သွယ်လာပါလိမ့်မည်။ လူကြီးမင်း၏ MyanmarAPN အင်တာဝန်ဆောင်မှုများနှင့်ပတ်သက်၍ စိတ်ဝင်စားမှုအပေါ် အထူးပင်ကျေးဇူးတင်ရှိပါသည်။</p>
      </div>
    </div>
    <div class="sub-form">
      <div class="form-container">
        <div class="generic-input">
          <label for="name">အမည် (Customer Name)</label>
          <input type="text" name="name"
                          :class="{'error': error.name}"
                          @keyup="onChange('name')"
                          v-model="subInfo.name" required>
        </div>

        <div class="generic-input">
          <label for="nrc">မှတ်ပုံတင်နံပါတ် (NRC)</label>
          <input type="text" name="nrc"
                          :class="{'error': error.nrc}"
                          @keyup="onChange('nrc')"
                          v-model="subInfo.nrc" required>
        </div>

        <div class="generic-input">
          <label for="phone">ဆက်သွယ်ရန်ဖုန်းနံပါတ် (Phone Number)</label>
          <input type="text" name="phone"
                          :class="{'error': error.phone}"
                          @keyup="onChange('phone')"
                          v-model="subInfo.phone" required>
        </div>

        <div class="generic-input">
          <label for="address">နေရပ်လိပ်စာ (Address)</label>
          <input type="text" name="address"
                          :class="{'error': error.address}"
                          @keyup="onChange('address')"
                          v-model="subInfo.address" required>
        </div>

        <div class="generic-input">
          <label for="city">မြို့ (City)</label>
          <v-select :options="['Yangon', 'Pyay']" v-model="subInfo.city"></v-select>
        </div>
        
        <div class="generic-input">
          <label for="township">မြို့နယ် (Township)</label>
          <input type="text" name="township"
              :class="{'error': error.township}"
              @keyup="onChange('township')"
              v-model="subInfo.township" required>
        </div>

        <div class="generic-input">
          <label for="township">Select a Plan</label>
          <div class="plan-selection">
            <label v-for="plan in plans" :key="plan.id" class="plan-radio" :class="{active: plan.id === subInfo.plan_id}" :for="plan.id">
              <input type="radio" :id="plan.id" name="plan" :value="plan.id" v-model="subInfo.plan_id">
              <div class="card">
                <div class="speed">{{ plan.speed.replace(' Mbps', '') }}<small>Mbps</small></div>
              </div>
              <div class="value">{{ plan.value }}</div>
            </label>
          </div>
        </div>

        <div class="btn-container">
          <button class="apn-btn--more" :disabled="working" @click="subscribe">Subscribe</button>
        </div>
      </div>
    </div>
    <section class="section--loading" v-show="working">
        <div class="lds-css ng-scope">
            <div style="width:100%;height:100%" class="lds-ellipsis">
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
                <div><div></div></div>
            </div>
        </div>
    </section>
    <apn-toast @close="onClose" :message="message" />
  </div>
</template>

<script>
export default {
  name: 'SubForm',
  data() {
    return {
      working: false,
      message: '',
      plans: null,
      subInfo: {
        name: '',
        nrc: '',
        phone: '',
        address: '',
        city: '',
        township: '',
        plan_id: '',
      },
      error: {
        name: false,
        nrc: false,
        phone: false,
        address: false,
        city: false,
        township: false,
        plan_id: false,
      },
      url: 'https://admin.myanmarapn.com/api/',
    }
  },
  methods: {
    async fetchPlans() {
      try {
        const res = (await this.axios.get(this.url + 'plan')).data
        this.plans = res.data[1].plan
      } catch(e) {
        console.log(e)
      }
    },

    onClose() {
      this.message = ''
    },

    async subscribe() {
      this.working = true
      try {
        const res = (await this.axios.post(this.url + 'subscribe', this.subInfo)).data
        this.clearAllInput()
        this.message = 'Your subscription success!'
      } catch(e) {
        console.log(e)
        this.message = 'Error occur! Please try again.'
      }

      this.working = false
    },

    onChange(val) {
      this.working = false

      // Remove Error Class on Changed Input Form
      this.error.val = false
    },

    clearInput(field) {
      this.subInfo.field = ''
    },

    clearAllInput() {
      Object.keys(this.subInfo).forEach(i => this.subInfo[i] = '')
    }

  },
  mounted() {
    console.log('afdfsdfsdf')
    this.fetchPlans()
  },
}
</script>

<style scoped lang="scss">

.section--loading {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fffe;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sub-form-container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;

  .intro {
    margin: 20px 0;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.08);
    overflow: hidden;
    img {
      width: 100%;
    }
    .description {
      padding: 20px 20px 25px;
      text-align: center;
      h1 {
        font-size: 2rem;
        color: var(--primary);
        margin: -10px 0 10px;
      }
      p {
        max-width: 600px;
        margin: 4px auto;
        padding: 0;
        color: #333;
        &.info {
          font-size: .9rem;
          color: var(--primary);
        }
      }
    }
  }

  .sub-form {
    width: 100%;
    padding: 40px 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.08);
    overflow: hidden;
    margin: 0 0 20px;

    .form-container {
      width: 100%;
      max-width: 600px;
      margin: 0 auto;
    }

    .plan-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 0 10px;
      .plan-radio {
        width: calc(25% - 8px);
        text-align: center;
        .card {
          width: 100%;
          height: 100px;
          border-radius: 4px;
          border: 1px solid #aaa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding-top: 14px;
          cursor: pointer;
        }
        @media (min-width: 992px) {
          width: calc(25% - 16px);
        }
        .speed {
          color: #444;
          font-weight: 700;
          font-size: 2.4rem;
          line-height: 1.6rem;
          small {
            font-size: .8rem;
            display: block;
            opacity: .8;
          }
        }
        &.active {
          .card {
            background-color: var(--primary);
            border-color: var(--primary);
            .speed {
              color: #fff;
            }
          }
        }
        .value {
          font-size: 1.2rem;
          margin-top: 5px;
        }
        input[type=radio] {
          width: 0;
          height: 0;
          overflow: hidden;
          position: absolute;
          z-index: -999;
        }
      }
    }

    .generic-input{
      padding: 0 10px;
      margin-bottom: 20px;

      label {
        font-size: 14px;
        color: #777;
        font-size: .8rem;
        font-weight: 400;
        padding: 5px 0;
        display: block;
      }

      input {
        width: 100%;
        min-height: 45px;
        background-color: transparent;
        border: 1px solid #aaa;
        border-radius: 4px;
        resize: none;
        padding: 0 15px;
        font-size: 1rem;
      }

      input.error {
        border: 1px solid red;
      }

      input:focus {
        outline: 1px solid var(--secondary);
        border: 1px solid var(--secondary);
      }

      select {
        width: 100%;
        padding: .8rem;
      }

      #city-selection {
        background: var(--primary);
        color: #fff;
        font-weight: bold;
        border-radius: 2px;
      }

    }

    .btn-container {
      display: flex;
      justify-content: flex-end;
      .apn-btn--more {
          align-self: flex-end;
          // Remove Later
          background-color: var(--primary);
          color: #fff;
          margin: 10px;
          &:disabled {
              cursor: not-allowed;
              opacity: .5;
          }
      }
    }

  }
}
</style>
